import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-yandex",
  "use": "icon-yandex-usage",
  "viewBox": "0 0 11 18",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 18\" id=\"icon-yandex\"><path d=\"M8.11786 2.4342H6.83137C4.47779 2.4342 3.23119 3.73317 3.23119 5.64342C3.23119 7.81565 4.08885 8.83081 5.85403 10.1189L7.31006 11.1777L3.12149 17.9891H0L3.75975 11.8981C1.59565 10.228 0.378966 8.60158 0.378966 5.82899C0.378966 2.35779 2.59293 0 6.81142 0H11V18H8.11786V2.4342Z\" fill=\"white\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol